import React, { useEffect, useState, useRef } from "react";
import { Button, Row, Col, Form, Modal, Select, Input, notification, Upload, Spin, message } from "antd";
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { componentStyles } from "./ProfileStyles";
import { editPreferences, getToKnowYouData, getUser, latestSubscription } from "../../api/password";
import ClipLoader from "react-spinners/ClipLoader";
import { useNavigate } from "react-router-dom";
import goBackButton from "../../assets/images/Go_Back.svg";
import "../onboarding/UserOnboardingPage.css";
import { getFinanceOptions, getPresignedUrl, getResourceOptions } from "../../api/AdditionalServices.js";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";

const { Option } = Select;

const MyPreferences = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [userId, setUserId] = useState(null);
    const [loader, setLoader] = useState(true);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [otherWebsites, setOtherWebsites] = useState([]);
    const [showPopup, setShowPopup] = React.useState(false);
    const popupRef = useRef(null);
    const [newWebsite, setNewWebsite] = useState({ name: "", url: "", type: "" });
    const [isFreePlan, setIsFreePlan] = useState(false);
    const [showFinancialModal, setShowFinancialModal] = useState(false);
    const [financialType, setFinancialType] = useState(null);
    const [companyName, setCompanyName] = useState(null);
    const [subtype, setSubtype] = useState(null);
    const [customSubtype, setCustomSubtype] = useState('');
    const [financialServices, setFinancialServices] = useState([]);
    const [financialUrl, setFinancialUrl] = useState('');
    const [newsResources, setNewsResources] = useState([]);
    const [quickLinks, setQuickLinks] = useState([]);
    const [leisureOptions, setLeisureOptions] = useState([]);
    const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [originalData, setOriginalData] = useState(null);
    const [userHobbies, setUserHobbies] = useState([]);
    const [financeOptions, setFinanceOptions] = useState([]);

    const [selectedTypeOptions, setSelectedTypeOptions] = useState({
      subtypes: [],
      companies: [],
    });
    const [previousSelections, setPreviousSelections] = useState({
        newsResource: [],
        quickLink: [],
        leisure: [],
    });

    const [preferences, setPreferences] = useState({
        newsResource: [],
        quickLink: [],
        leisure: [],
        financialServices: [],
        otherWebsite: []
    });

    const fetchFinanceOptions = async () => {
        try {
            const response = await getFinanceOptions();
            setFinanceOptions(response.data);
        } catch (error) {
            console.error("Error fetching finance options:", error);
            notification.error({
                message: 'Error',
                description: 'Failed to fetch finance options'
            });
        }
    };

    useEffect(() => {
      fetchFinanceOptions();
    }, []);

    const handleFileChange = ({ file }) => {
        setSelectedFile(file);
        setNewWebsite(prev => ({ ...prev, imageFile: file }));
    };


    const uploadImageToS3 = async (file) => {
        try {
            const fileType = file.type;
            const response = await getPresignedUrl({ fileType: fileType });
            const presignedUrl = response.uploadUrl;
            const uploadResponse = await fetch(presignedUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': fileType,
                },
                body: file,
            });

            if (uploadResponse.ok) {
                const imageUrl = presignedUrl.split('?')[0];
                return imageUrl;
            } else {
                throw new Error("Upload to S3 failed");
            }
        } catch (error) {
            console.error("Error uploading file: ", error);
            throw error;
        }
    };

    const fetchResourceOptions = async () => {
        try {
            const response = await getResourceOptions();
            const data = response.resources;
            setNewsResources(data.News);
            setQuickLinks(data.Game);
            setLeisureOptions(data.Leisure);
            setUserHobbies(response.hobbies);
        } catch (error) {
            console.error('', error);
            setNewsResources([]);
            setQuickLinks([]);
            setLeisureOptions([]);
            setUserHobbies([]);
        }
    };

    useEffect(() => {
        fetchResourceOptions();
    }, []);

    const openFinancialModal = () => {
        setShowFinancialModal(true);
        setFinancialType(null);
        setCompanyName(null);
        setSubtype(null);
        setCustomSubtype('');
    };

    const closeFinancialModal = () => {
        setShowFinancialModal(false);
    };

    const handleFinancialTypeChange = (value) => {
        setFinancialType(value);
        setCompanyName(null);
        setSubtype(null);
        setCustomSubtype('');
        
        const selectedType = financeOptions.find(option => option.type_of_finance === value);
        if (selectedType) {
            setSelectedTypeOptions({
                subtypes: selectedType.subtype_of_finance,
                companies: selectedType.company_name
            });
        }
    };

    const handleCompanyNameChange = (value) => {
        const selectedCompany = selectedTypeOptions.companies.find(company => company.name === value);
        setCompanyName(value);
    };

    const handleSubtypeChange = (value) => {
        setSubtype(value);
    };

    const handleSearch = (input, setOptions, currentOptions) => {
        if (input && !currentOptions.includes(input)) {
            setOptions([...currentOptions, input]);
        }
    };

    const addFinancialService = () => {
        if (financialType && companyName && (subtype || customSubtype) && financialUrl) {
            const selectedCompany = selectedTypeOptions.companies.find(company => company.name === companyName);
            
            const newService = {
                type_of_finance: financialType,
                company_name: companyName,
                subtype_of_finance: subtype === 'other' ? customSubtype : subtype,
                url: financialUrl,
                imageUrl: selectedCompany ? selectedCompany.imageUrl : null
            };

            setFinancialServices(prevServices => [...prevServices, newService]);
            closeFinancialModal();
        }
    };


    const handleUrlChange = (e) => {
        setFinancialUrl(e.target.value);
    };

    const removeFinancialService = (index) => {
        setFinancialServices(prevServices => {
            const updatedServices = prevServices.filter((_, i) => i !== index);
            return updatedServices;
        });
    };

    const renderCompanyOptions = () => {
      return selectedTypeOptions.companies.map((company) => (
        <Option key={company.name} value={company.name}>
          {company.name}
        </Option>
      ));
    };

    const renderSubtypeOptions = () => {
      return selectedTypeOptions.subtypes.map((subtype) => (
        <Option key={subtype} value={subtype}>
          {subtype}
        </Option>
      ));
    };

    const addAdditionalWebsite = async () => {
        if (newWebsite.name && newWebsite.url && newWebsite.type) {
            let isDuplicate = false;
            let existingPreferences;

            switch (newWebsite.type) {
                case 'news':
                    existingPreferences = preferences.newsResource;
                    break;
                case 'game':
                    existingPreferences = preferences.quickLink;
                    break;
                case 'leisure':
                    existingPreferences = preferences.leisure;
                    break;
                default:
                    existingPreferences = [];
            }

            isDuplicate = existingPreferences.some(item => 
                item.name.toLowerCase() === newWebsite.name.toLowerCase()
            );

            if (isDuplicate) {
                notification.error({
                    message: 'Duplicate Entry',
                    description: `A preference with the name "${newWebsite.name}" already exists in ${newWebsite.type} category.`,
                    duration: 4.5
                });
                return;
            }
            
            setIsLoading(true);
            try {
                let imageUrl = null;
                if (selectedFile) {
                    imageUrl = await uploadImageToS3(selectedFile);
                }

                const updatedOtherWebsites = [
                    ...otherWebsites,
                    { ...newWebsite, imageUrl: imageUrl }
                ];
                setOtherWebsites(updatedOtherWebsites);

                const dataToSend = {
                    newsResource: originalData.newsResource.map(item => ({
                        name: item.name,
                        url: item.url,
                        imageUrl: item.imageUrl
                    })),

                    quickLink: [
                        ...originalData.quickLink.map(item => ({
                            name: item.name,
                            url: item.url,
                            imageUrl: item.imageUrl
                        })),
                        ...updatedOtherWebsites
                            .filter(website => website.type === 'game')
                            .map(website => ({
                                name: website.name,
                                url: website.url,
                                imageUrl: website.imageUrl
                            }))
                    ],

                    leisure: [
                        ...originalData.leisure.map(item => ({
                            name: item.name,
                            url: item.url,
                            imageUrl: item.imageUrl
                        })),
                        ...updatedOtherWebsites
                            .filter(website => website.type === 'leisure')
                            .map(website => ({
                                name: website.name,
                                url: website.url,
                                imageUrl: website.imageUrl
                            }))
                    ],

                    newsResource: [
                        ...originalData.newsResource.map(item => ({
                            name: item.name,
                            url: item.url,
                            imageUrl: item.imageUrl
                        })),
                        ...updatedOtherWebsites
                            .filter(website => website.type === 'news')
                            .map(website => ({
                                name: website.name,
                                url: website.url,
                                imageUrl: website.imageUrl
                            }))
                    ],

                    financialServices: financialServices,

                    otherWebsite: updatedOtherWebsites.filter(website =>
                        !['news', 'game', 'leisure'].includes(website.type)
                    ).map(website => ({
                        name: website.name,
                        url: website.url,
                        imageUrl: website.imageUrl,
                        type: website.type
                    }))
                };

                setNewWebsite({ name: "", url: "", type: "", imageFile: null });
                setSelectedFile(null);
                setShowPopup(false);

            } catch (error) {
                notification.error({
                    message: 'Upload Failed',
                    description: error.message || 'An error occurred while uploading the file.',
                    duration: 10
                });
            } finally {
                setIsLoading(false);
            }
        } else {
            console.error("Please fill in all required fields.");
        }
    };

    const handleRemoveTag = (siteToRemove) => {
        setOtherWebsites(otherWebsites.filter(site => site !== siteToRemove));
    };

    const handlePopupSubmit = (e) => {
        e.preventDefault();
        addAdditionalWebsite();
    };

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setShowPopup(false);
        }
    };

    useEffect(() => {
        const fetchLatestSubscriptionData = async () => {
            try {
                const response = await latestSubscription();
                setIsFreePlan(response.subscriptionDetails.planName === "Free Plan");
            } catch (err) {
                console.error("Error fetching subscription data:", err);
            }
        };

        fetchLatestSubscriptionData();
    }, []);

    useEffect(() => {
        if (showPopup) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showPopup]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoader(true);
                const response = await getToKnowYouData();
                setOriginalData(response);
                setFinancialServices(
                    response.financialServices || []
                );

                setPreferences({
                    newsResource: response.newsResource || [],
                    quickLink: response.quickLink || [],
                    leisure: response.leisure || [],
                    financialServices: response.financialServices || [],
                    otherWebsite: response.otherWebsite || []
                });
                setPreviousSelections({
                    newsResource: response.newsResource || [],
                    quickLink: response.quickLink || [],
                    leisure: response.leisure || [],
                });
                setUserHobbies(response.hobbies || [])
                if (response) {
                    form.setFieldsValue({
                        preferredNewsSource: response.newsResource ? response.newsResource.map(item => item.name) : [],
                        gamesPreferences: response.quickLink ? response.quickLink.map(item => item.name) : [],
                        leisurePreferences: response.leisure ? response.leisure.map(item => item.name) : [],
                        hobbies: response.hobbies || []
                    });
                }
            } catch (err) {
                console.error("Error fetching data:", err);
            } finally {
                setLoader(false);
            }
        };

        fetchData();
    }, [form]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoader(true);
                const response = await getUser();
                setUserId(response.id);
            } catch (err) {
                console.error("Error fetching User Id:", err);
            } finally {
                setLoader(false);
            }
        };
        fetchData();
    }, []);

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleBack = () => {
        navigate("/landing-page");
    };

    const sectionsContainerStyle = {
        transition: "opacity 0.3s ease, pointer-events 0.3s ease",
        opacity: isDrawerOpen ? "0.5" : "1",
        pointerEvents: isDrawerOpen ? "none" : "auto",
    };

    const handleSave = async () => {
        try {

            const dataToSend = {
                newsResource: preferences.newsResource,
                quickLink: preferences.quickLink,
                leisure: preferences.leisure,
                hobbies: userHobbies,  
                financialServices: financialServices,
                otherWebsite: isFreePlan ? [] : otherWebsites.map(website => ({
                    name: website.name,
                    url: website.url,
                    imageUrl: website.imageUrl,
                    type: website.type
                }))
            };

            await editPreferences(userId, dataToSend);

            setPreviousSelections({
                newsResource: preferences.newsResource,
                quickLink: preferences.quickLink,
                leisure: preferences.leisure,
                hobbies: userHobbies, 
            });

            Modal.success({
                title: 'Preferences Edited Successfully',
                content: 'Your preferences have been updated successfully.',
                onOk() { },
            });
            fetchResourceOptions();
        } catch (err) {
            console.error("Error saving preferences:", err);
            Modal.error({
                title: 'Error Saving Preferences',
                content: 'There was an error saving your preferences. Please try again.',
            });
        }
    };

    const handleSelectChange = (fieldName, selectedValues) => {
        form.setFieldsValue({ [fieldName]: selectedValues });

        const selectedArray = Array.isArray(selectedValues) ? selectedValues : [selectedValues];

        const updatedPreferences = { ...preferences };
        const correspondingField = {
            preferredNewsSource: 'newsResource',
            gamesPreferences: 'quickLink',
            leisurePreferences: 'leisure'
        }[fieldName];

        if (correspondingField) {
            let optionsArray;
            switch (correspondingField) {
                case 'newsResource':
                    optionsArray = newsResources;
                    break;
                case 'quickLink':
                    optionsArray = quickLinks;
                    break;
                case 'leisure':
                    optionsArray = leisureOptions;
                    break;
                default:
                    optionsArray = [];
            }

            updatedPreferences[correspondingField] = selectedArray.map(name => {
                const existingItem = preferences[correspondingField].find(item => item.name === name);
                if (existingItem) {
                    return existingItem;
                }

                const optionItem = optionsArray.find(item => item.name === name);
                if (optionItem) {
                    return {
                        name: optionItem.name,
                        url: optionItem.url || '',
                        imageUrl: optionItem.imageUrl || ''
                    };
                }

                return { name, url: '', imageUrl: '' };
            });
            setPreferences(updatedPreferences);
        }
    };

    const handleHobbiesChange = (value) => {
      setUserHobbies(value); 
    };

    const handleKeyDown = (event) => {
      const inputValue = event.target.value;

      if (inputValue.length >= 100 && event.key !== "Backspace") {
        event.preventDefault();
        message.warning("Each entry should not exceed 100 characters.");
      }
    };

    return (
      <div
        style={{
          minHeight: "100dvh",
          overflow: "hidden",
          background: "#fefcfe",
        }}
      >
        <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
          <Row
            justify={{
              xs: "space-around",
              md: "space-around",
              lg: "space-between",
            }}
            style={{ marginBottom: 20 }}
          >
            <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
              <UserHeader setDrawer={openDrawer} />
            </Col>
            {isDrawerOpen && (
              <Col span={4}>
                <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
              </Col>
            )}
          </Row>
          <button
            onClick={handleBack}
            className="text-left pl-4 button-styling setBackButton"
          >
            <img src={goBackButton} alt="Go Back Button" />
          </button>
          {loader ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "200px",
              }}
            >
              <ClipLoader
                loading={loader}
                size={50}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
          ) : (
            <Form form={form}>
              <Row justify="center" style={{ padding: "25px" }}>
                <Col span={20} style={{ paddingLeft: "2%" }}>
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <Row style={componentStyles.rowStyling}>
                        <h1 style={componentStyles.headingStyle}>
                          Edit Your Preferences
                        </h1>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      lg={{ span: 16, offset: 4 }}
                      md={{ span: 16, offset: 4 }}
                      xs={{ span: 24, offset: 0 }}
                      sm={{ span: 24, offset: 0 }}
                    >
                      <Row style={componentStyles.rowStyle}>
                        <Col
                          lg={{ span: 24, offset: 0 }}
                          md={{ span: 24, offset: 0 }}
                          xs={{ span: 24, offset: 0 }}
                          sm={{ span: 24, offset: 0 }}
                        >
                          <Form.Item
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            name="preferredNewsSource"
                            label={
                              <span style={componentStyles.labelStyle}>
                                News Preferences
                              </span>
                            }
                          >
                            <Select
                              mode={isFreePlan ? undefined : "multiple"}
                              placeholder="Select Your News Preferences"
                              style={{
                                ...componentStyles.selectStyle,
                                boxShadow: "none",
                                border: "none",
                                background: "none",
                                outline: "none",
                              }}
                              onChange={(value) =>
                                handleSelectChange("preferredNewsSource", value)
                              }
                              maxTagCount={isFreePlan ? 1 : 5}
                              maxTagPlaceholder={(omittedValues) =>
                                `+${omittedValues.length} more`
                              }
                              maxTagTextLength={isFreePlan ? 1 : undefined}
                            >
                              {newsResources.map((resource) => (
                                <Option
                                  key={resource.name}
                                  value={resource.name}
                                >
                                  {resource.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row style={componentStyles.rowStyle}>
                        <Col
                          lg={{ span: 24, offset: 0 }}
                          md={{ span: 24, offset: 0 }}
                          xs={{ span: 24, offset: 0 }}
                          sm={{ span: 24, offset: 0 }}
                        >
                          <Form.Item
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            name="gamesPreferences"
                            label={
                              <span style={componentStyles.labelStyle}>
                                Games Preferences
                              </span>
                            }
                          >
                            <Select
                              mode={isFreePlan ? undefined : "multiple"}
                              placeholder="Select Your Games Preferences"
                              style={{
                                ...componentStyles.selectStyle,
                                boxShadow: "none",
                                border: "none",
                                background: "none",
                                outline: "none",
                              }}
                              onChange={(value) =>
                                handleSelectChange("gamesPreferences", value)
                              }
                              maxTagCount={isFreePlan ? 1 : 5}
                              maxTagPlaceholder={(omittedValues) =>
                                `+${omittedValues.length} more`
                              }
                              maxTagTextLength={isFreePlan ? 1 : undefined}
                            >
                              {quickLinks.map((link) => (
                                <Option key={link.name} value={link.name}>
                                  {link.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row style={componentStyles.rowStyle}>
                        <Col
                          lg={{ span: 24, offset: 0 }}
                          md={{ span: 24, offset: 0 }}
                          xs={{ span: 24, offset: 0 }}
                          sm={{ span: 24, offset: 0 }}
                        >
                          <Form.Item
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            name="leisurePreferences"
                            label={
                              <span style={componentStyles.labelStyle}>
                                Leisure Preferences
                              </span>
                            }
                          >
                            <Select
                              mode={isFreePlan ? undefined : "multiple"}
                              placeholder="Select Your Leisure Preferences"
                              style={{
                                ...componentStyles.selectStyle,
                                boxShadow: "none",
                                border: "none",
                                background: "none",
                                outline: "none",
                              }}
                              onChange={(value) =>
                                handleSelectChange("leisurePreferences", value)
                              }
                              maxTagCount={isFreePlan ? 1 : 5}
                              maxTagPlaceholder={(omittedValues) =>
                                `+${omittedValues.length} more`
                              }
                              maxTagTextLength={isFreePlan ? 1 : undefined}
                            >
                              {leisureOptions.map((option) => (
                                <Option key={option.name} value={option.name}>
                                  {option.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={{ span: 24, offset: 0 }}
                          md={{ span: 24, offset: 0 }}
                          xs={{ span: 24, offset: 0 }}
                          sm={{ span: 24, offset: 0 }}
                        >
                          <Form.Item
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            name="hobbies"
                            label={
                              <span style={componentStyles.labelStyle}>
                                Tell us more about you, your hobbies and
                                interests by adding the options below.
                              </span>
                            }
                          >
                            <Select
                              className="preference-hobbies"
                              mode="tags"
                              allowClear
                              placeholder="Hobbies"
                              defaultValue={userHobbies}
                              value={userHobbies}
                              onChange={handleHobbiesChange}
                              tokenSeparators={[","]}
                              open={false}
                              onInputKeyDown={handleKeyDown}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row style={componentStyles.rowStyle}>
                        <Col
                          lg={{ span: 24, offset: 0 }}
                          md={{ span: 24, offset: 0 }}
                          xs={{ span: 24, offset: 0 }}
                          sm={{ span: 24, offset: 0 }}
                        >
                          <Form.Item
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            name="financialServices"
                            label={
                              <span style={componentStyles.labelStyle}>
                                Financial Services
                              </span>
                            }
                          >
                            <div style={componentStyles.multiSelectContainer}>
                              <div className="tags-container">
                                {financialServices.map((service, index) => (
                                  <span key={index} className="tag">
                                    {`${service.type_of_finance} - ${service.company_name} (${service.subtype_of_finance})`}
                                    <button
                                      type="button"
                                      style={componentStyles.crossTag}
                                      onClick={() =>
                                        removeFinancialService(index)
                                      }
                                    >
                                      x
                                    </button>
                                  </span>
                                ))}
                              </div>
                              <button
                                type="button"
                                style={{
                                  ...componentStyles.additionalServices,
                                  marginTop: "5px",
                                }}
                                onClick={openFinancialModal}
                                disabled={
                                  isFreePlan && financialServices.length >= 1
                                }
                              >
                                Add Financial Service
                              </button>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>

                      {!isFreePlan && (
                        <Row style={componentStyles.rowStyle}>
                          <Col
                            lg={{ span: 24 }}
                            md={{ span: 24 }}
                            xs={{ span: 24 }}
                          >
                            <Form.Item
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              name="additionalPreferences"
                              label={
                                <span style={componentStyles.labelStyle}>
                                  Additional Preferences
                                </span>
                              }
                            >
                              <div style={componentStyles.multiSelectContainer}>
                                <div className="tags-container">
                                  {otherWebsites.map((site) => (
                                    <span key={site.name} className="tag">
                                      {site.name}
                                      <button
                                        type="button"
                                        style={componentStyles.crossTag}
                                        onClick={() => handleRemoveTag(site)}
                                      >
                                        x
                                      </button>
                                    </span>
                                  ))}
                                </div>
                                <button
                                  type="button"
                                  style={{
                                    ...componentStyles.additionalServices,
                                    marginTop: "5px",
                                  }}
                                  onClick={() => setShowPopup(true)}
                                >
                                  Add Website
                                </button>
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
                      )}

                      {showPopup && (
                        <div style={componentStyles.popUp} ref={popupRef}>
                          <div style={componentStyles.popInner}>
                            <h2 style={componentStyles.popupTitle}>
                              Add a new website
                            </h2>
                            <Form>
                              <div style={componentStyles.formField}>
                                <label
                                  htmlFor="websiteName"
                                  style={componentStyles.formLabel}
                                >
                                  Name{" "}
                                  <i style={componentStyles.requiredInput}>*</i>
                                </label>
                                <input
                                  id="websiteName"
                                  type="text"
                                  value={newWebsite.name}
                                  onChange={(e) =>
                                    setNewWebsite({
                                      ...newWebsite,
                                      name: e.target.value,
                                    })
                                  }
                                  required
                                  style={componentStyles.formInput}
                                />
                              </div>
                              <div style={componentStyles.formField}>
                                <label
                                  htmlFor="websiteUrl"
                                  style={componentStyles.formLabel}
                                >
                                  URL{" "}
                                  <i style={componentStyles.requiredInput}>*</i>
                                </label>
                                <input
                                  id="websiteUrl"
                                  type="text"
                                  value={newWebsite.url}
                                  onChange={(e) =>
                                    setNewWebsite({
                                      ...newWebsite,
                                      url: e.target.value,
                                    })
                                  }
                                  required
                                  style={componentStyles.formInput}
                                />
                              </div>
                              <div style={componentStyles.formField}>
                                <label
                                  htmlFor="websiteType"
                                  style={componentStyles.formLabel}
                                >
                                  Type{" "}
                                  <i style={componentStyles.requiredInput}>*</i>
                                </label>
                                <select
                                  name="type"
                                  id="websiteType"
                                  value={newWebsite.type}
                                  onChange={(e) =>
                                    setNewWebsite({
                                      ...newWebsite,
                                      type: e.target.value,
                                    })
                                  }
                                  required
                                  style={componentStyles.formInput}
                                >
                                  <option value="" disabled>
                                    Select the type for URL
                                  </option>
                                  <option value="news">News</option>
                                  <option value="game">Game</option>
                                  <option value="leisure">Leisure</option>
                                </select>
                              </div>

                              <div style={componentStyles.formField}>
                                <label
                                  htmlFor="websiteImage"
                                  style={componentStyles.formLabel}
                                >
                                  Image
                                </label>
                                <Upload
                                  beforeUpload={() => false}
                                  onChange={handleFileChange}
                                  maxCount={1}
                                >
                                  <Button icon={<UploadOutlined />}>
                                    Upload Image (Optional)
                                  </Button>
                                </Upload>
                                {uploadedImageUrl && (
                                  <p>Image uploaded successfully</p>
                                )}
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  marginTop: "20px",
                                }}
                              >
                                <Button
                                  type="submit"
                                  onClick={handlePopupSubmit}
                                  style={componentStyles.formButton}
                                >
                                  {isLoading ? (
                                    <Spin
                                      indicator={
                                        <LoadingOutlined
                                          style={{ fontSize: 24 }}
                                          spin
                                        />
                                      }
                                    />
                                  ) : (
                                    "Add"
                                  )}
                                </Button>
                                <Button
                                  type="button"
                                  onClick={() => {
                                    setShowPopup(false);
                                    setSelectedFile(null);
                                  }}
                                  style={componentStyles.cancelButton}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Form>
                          </div>
                        </div>
                      )}
                      <Row style={{ ...componentStyles.rowStyle }}>
                        <Col span={24} style={componentStyles.buttonColStyling}>
                          <Button
                            onClick={handleBack}
                            style={{
                              ...componentStyles.marginRight,
                              ...componentStyles.cancelButtonStyle,
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={handleSave}
                            type="primary"
                            style={componentStyles.saveButtonStyle}
                          >
                            Save
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          )}
        </Col>
        <Modal
          title="Add Financial Service"
          visible={showFinancialModal}
          onOk={addFinancialService}
          onCancel={closeFinancialModal}
          okText="Add"
          cancelText="Cancel"
          footer={[
            <div
              key="footer"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Button
                type="submit"
                onClick={addFinancialService}
                style={componentStyles.formButton}
              >
                Add
              </Button>
              <Button
                type="button"
                onClick={closeFinancialModal}
                style={componentStyles.cancelButton}
              >
                Cancel
              </Button>
            </div>,
          ]}
        >
          <Form layout="vertical">
            <Form.Item label="Type of Finance" required>
              <Select
                value={financialType}
                onChange={handleFinancialTypeChange}
                style={{
                  boxShadow: "none",
                  border: "none",
                  background: "none",
                  outline: "none",
                }}
              >
                {financeOptions.map((type) => (
                  <Option
                    key={type.type_of_finance}
                    value={type.type_of_finance}
                  >
                    {type.type_of_finance}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {financialType && (
              <Form.Item label="Subtype" required>
                <Select
                  value={subtype}
                  onChange={handleSubtypeChange}
                  style={{
                    boxShadow: "none",
                    border: "none",
                    background: "none",
                    outline: "none",
                  }}
                >
                  {renderSubtypeOptions()}
                </Select>
              </Form.Item>
            )}

            {financialType && subtype && (
              <Form.Item label="Company Name" required>
                <Select
                  value={companyName}
                  onChange={handleCompanyNameChange}
                  style={{
                    boxShadow: "none",
                    border: "none",
                    background: "none",
                    outline: "none",
                  }}
                >
                  {renderCompanyOptions()}
                </Select>
              </Form.Item>
            )}

            {financialType && subtype && companyName && (
              <Form.Item
                label="URL"
                name="url"
                rules={[
                  { required: true, message: "Please input the URL!" },
                  { type: "url", message: "Please enter a valid URL!" },
                ]}
              >
                <Input
                  value={financialUrl}
                  onChange={handleUrlChange}
                  placeholder="Enter the URL"
                  style={{
                    boxShadow: "none",
                    border: "none",
                    background: "none",
                    outline: "none",
                  }}
                />
              </Form.Item>
            )}
          </Form>
        </Modal>
      </div>
    );
};

export default MyPreferences;